import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * A person's answer to a human wait: the option they chose (or `null` for a
 * free-text-only answer), the text they gave, and who they are.
 *
 * @since 1.0.0
 */
export const LoopHumanAnswer = Schema.Struct({
  option: Schema.NullOr(Schema.String),
  text: Schema.String,
  by: Schema.String,
});
export type LoopHumanAnswer = Schema.Schema.Type<typeof LoopHumanAnswer>;

/**
 * Loop human wait model — a node that asks a person a question and parks
 * (OL-203).
 *
 * `customerId` / `invocationId` / `executorId` are by id only.
 *
 * @since 1.0.0
 */
export class LoopHumanWait extends Model.Class<LoopHumanWait>("LoopHumanWait")({
  id: Model.Generated(Schema.String),

  customerId: Schema.String,

  invocationId: Schema.String,
  executorId: Schema.String,
  claim: Schema.String,
  node: Schema.String,

  prompt: Schema.String,
  options: Schema.Array(Schema.String),

  notifiedAt: Schema.NullOr(Schema.DateTimeUtc),
  notifyChannel: Schema.NullOr(Schema.String),
  renotifyCount: Schema.Number,

  answeredAt: Schema.NullOr(Schema.DateTimeUtc),
  answer: Schema.NullOr(LoopHumanAnswer),

  partialRef: Schema.NullOr(Schema.String),

  deferredToken: Schema.NullOr(Schema.String),

  createdAt: Model.DateTimeInsertFromDate,
  updatedAt: Model.DateTimeUpdateFromDate,
}) {}
